import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { md3 } from 'vuetify/blueprints'
import { mdi } from 'vuetify/iconsets/mdi'

export default defineNuxtPlugin({
  name: 'vuetify',
  parallel: true,
  setup(nuxtApp) {
    const vuetify = createVuetify({
      blueprint: md3,
      components,
      directives,
      ssr: true, // Enable SSR support
      theme: {
        defaultTheme: 'light',
        themes: {
          light: {
            colors: {
              primary: '#7367F0',
              secondary: '#82868B',
              accent: '#9C88FF',
              error: '#EA5455',
              info: '#00CFE8',
              success: '#28C76F',
              warning: '#FF9F43',
              surface: '#FFFFFF',
              background: '#F8F7FA',
              'surface-variant': '#F3F2F7',
              'on-surface': '#4A5568',
              'on-surface-variant': '#6B7280',
            },
          },
          dark: {
            colors: {
              primary: '#7367F0',
              secondary: '#8A8D93',
              accent: '#9C88FF',
              error: '#EA5455',
              info: '#00CFE8',
              success: '#28C76F',
              warning: '#FF9F43',
              surface: '#2F3349',
              background: '#25293C',
              'surface-variant': '#3A3E5C',
              'on-surface': '#CFD3EC',
              'on-surface-variant': '#A8AAC4',
            },
          },
        },
      },
      icons: {
        defaultSet: 'mdi',
        sets: {
          mdi,
        },
      },
    })

    nuxtApp.vueApp.use(vuetify)
  },
})
